import { BadgeDirective } from './badge.directive';
import { DropdownMenuDirective } from './dropdown-menu.directive';
import { DropdownToggleDirective } from './dropdown-toggle.directive';
import { DropdownDirective } from './dropdown.directive';
import { ErrorDirective } from './error.directive';
import { HintDirective } from './hint.directive';
import { InputDirective } from './input.directive';
import { LabelDirective } from './label.directive';
import { LinkDirective } from './link.directive';
import { TabsContentItemDirective } from './tabs-content-item.directive';

export const UIKIT_DIRECTIVES = [
  ErrorDirective,
  HintDirective,
  InputDirective,
  LinkDirective,
  BadgeDirective,
  LabelDirective,
  TabsContentItemDirective,
  DropdownToggleDirective,
  DropdownMenuDirective,
  DropdownDirective,
];

export { BadgeDirective } from './badge.directive';
export { DropdownMenuDirective } from './dropdown-menu.directive';
export { DropdownToggleDirective } from './dropdown-toggle.directive';
export { DropdownDirective } from './dropdown.directive';
export { ErrorDirective } from './error.directive';
export { HintDirective } from './hint.directive';
export { InputDirective } from './input.directive';
export { LabelDirective } from './label.directive';
export { LinkDirective } from './link.directive';
export { TabsContentItemDirective } from './tabs-content-item.directive';
